import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';

import {
  makeGetReportData,
  makeGetReportMeasure,
  makeGetReportType,
} from '../../../../redux/state-areas/reports/entities/selectors';

import ChartWrapper from '../dashboard-widgets/charts/ChartWrapper';

const REPORT_CHART_WRAPPER_STYLE = { height: '100%' };

const ReportChartWrapper = ({
  chartType,
  isLoading,
  measure,
  reportData,
  handleSliceClick,
  onNumberClick,
  chartTitle,
  maxHeight = '700px',
  renderDelay = 0,
  isFullscreen = false,
}) => {
  const [shouldRender, setShouldRender] = useState(renderDelay === 0);
  const containerRef = useRef();

  const innerContainerStyle = useMemo(
    () => ({
      width: '100%',
      maxWidth: '1200px',
      aspectRatio: '16/9',
      maxHeight,
      height: '100%',
      minHeight: 0,
      minWidth: 0,
    }),
    [maxHeight],
  );

  useEffect(() => {
    if (renderDelay === 0) return;
    const timer = setTimeout(() => {
      if (containerRef.current?.offsetWidth > 0) {
        setShouldRender(true);
      } else {
        // Container not laid out yet — wait one frame
        requestAnimationFrame(() => setShouldRender(true));
      }
    }, renderDelay);
    return () => clearTimeout(timer);
  }, [renderDelay]);

  return (
    <div
      ref={containerRef}
      className="report-chart-wrapper w-full h-full flex p-2 items-center justify-center"
      style={REPORT_CHART_WRAPPER_STYLE}
    >
      <div style={innerContainerStyle}>
          <ChartWrapper
            chartType={chartType}
            data={reportData}
            isLoading={isLoading || !shouldRender}
            measure={measure}
            handleSliceClick={handleSliceClick}
            onNumberClick={onNumberClick}
            chartTitle={chartTitle}
            isFullscreen={isFullscreen}
          />
      </div>
    </div>
  );
};

const makeMapStateToProps = () => {
  const getReportData = makeGetReportData();
  const getReportType = makeGetReportType();
  const getReportMeasure = makeGetReportMeasure();
  return (state, ownProps) => ({
    reportData: getReportData(state, ownProps),
    chartType: getReportType(state, ownProps),
    measure: getReportMeasure(state, ownProps),
  });
};

export default connect(makeMapStateToProps)(ReportChartWrapper);
